// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as $$Promise from "@ryyppy/rescript-promise/src/Promise.bs.js";

function then_(prim0, prim1) {
  return prim0.then(Curry.__1(prim1));
}

function thenResolve(prim0, prim1) {
  return prim0.then(Curry.__1(prim1));
}

var $$Promise$1 = {
  JsError: $$Promise.JsError,
  $$catch: $$Promise.$$catch,
  then_: then_,
  thenResolve: thenResolve
};

export {
  $$Promise$1 as $$Promise,
  
}
/* No side effect */
